import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App';
import { UiThemeProvider } from './contexts/UiThemeContext';
import { AuthProvider } from './contexts/AuthContext';
// Switched to queue-based notification context (provides useNotify)
import { NotificationProvider } from './contexts/NotificationContext';
import { RateLimitProvider } from './contexts/RateLimitContext';
import { registerServiceWorker } from './serviceWorkerRegistration';


// Create a query client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <UiThemeProvider>
          <NotificationProvider>
            <RateLimitProvider>
              <AuthProvider>
                <App />
              </AuthProvider>
            </RateLimitProvider>
          </NotificationProvider>
        </UiThemeProvider>
      </BrowserRouter>

    </QueryClientProvider>
  </React.StrictMode>
);

registerServiceWorker();
